import { motion } from 'framer-motion'
import React from 'react'

import GalaxyBackground from '@/components/GalaxyBackground'
import { Button } from '@/components/ui/button'
import appSettings from '@/config/appSettings'
import { useMsal } from '@azure/msal-react'

const AuthenticationPageLayout = ({
  children,
  showAppLogo,
}: {
  children: React.ReactNode
  showAppLogo?: boolean
}) => {
  const [firstAnimation, setFirstAnimation] = React.useState(true)
  const { name = '', logo } = appSettings

  return (
    <div className='relative flex h-screen flex-col justify-center overflow-y-auto bg-neutral-950'>
      <div className='absolute h-full w-full'>
        <GalaxyBackground
          mouseInteraction={false}
          disableAnimation={false}
          mouseRepulsion={false}
          density={0.8}
          glowIntensity={0.2}
          saturation={0}
          hueShift={140}
          starSpeed={0.1}
          rotationSpeed={0.1}
        />
      </div>

      <div className='z-10 px-2 py-4 sm:px-6 sm:py-12 lg:px-8'>
        <div className='sm:mx-auto sm:w-full sm:max-w-md'>
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: firstAnimation ? 0.4 : 0 }}
            onAnimationComplete={() => setFirstAnimation(false)}
            className='rounded-md bg-black/80 px-4 py-12 shadow-lg sm:rounded-lg sm:px-10'
          >
            <div className='sm:mx-auto sm:w-full sm:max-w-md'>
              {showAppLogo && (
                <div className='flex items-center justify-center'>
                  <div className='draggable-handle z-10'>
                    <img
                      className='pointer-events-none h-36 w-auto rounded'
                      src={logo}
                      alt={`${name} logo`}
                    />
                  </div>
                </div>
              )}
              {children}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

const Login = () => {
  const { instance } = useMsal()
  const { name = '', description = '' } = appSettings

  const handleLogin = () => {
    instance.loginRedirect()
  }

  return (
    <AuthenticationPageLayout showAppLogo>
      <div>
        <h2 className='mt-8 text-center text-3xl font-extrabold text-white/90'>
          Welcome to {name}
        </h2>
        <p className='max-w mt-4 text-center text-sm text-white/90'>
          {description}
        </p>
        <div className='mt-8 flex items-center justify-around'>
          <Button
            type='button'
            variant='secondary'
            size='lg'
            onClick={handleLogin}
            aria-label='Sign in with Your Corporate Login'
          >
            Sign in with Your Corporate Login
          </Button>
        </div>
      </div>
    </AuthenticationPageLayout>
  )
}

export default Login
